// extracted by mini-css-extract-plugin
export default {"modal-header":"GenerateJEModel_modal-header__L1kPj","close-icon":"GenerateJEModel_close-icon__Tnrwa","modal-body":"GenerateJEModel_modal-body__2tAdd"};